import { createContext } from 'react';
const RealtimeContext = createContext(undefined);
export default RealtimeContext;
